/*
 * Layout for the landlord user list
 */

define(["marionette", "./template/landlordUsersTemplate.html"], function (
  Marionette,
  LandlordUsersTemplate,
) {
  var LandlordUsersView = {
    landlordUsersView: Marionette.Layout.extend({
      template: LandlordUsersTemplate,
      triggers: {
        "click #addUser": "add:user",
      },
      regions: {
        landlordUsersList: "#landlordUsersList",
      },
    }),
  };

  return LandlordUsersView;
});
